var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-popover",
    {
      ref: "popover",
      staticClass: "time-tracking__project__popover",
      on: { show: _vm.handleShow, hide: _vm.handleHide }
    },
    [
      _c(
        "div",
        { staticClass: "q-pa-md" },
        [
          _c("q-search", {
            staticClass: "time-tracking__project__search",
            attrs: {
              "inverted-light": "",
              color: "blue-grey-1",
              debounce: _vm.defaultSearchDebounce
            },
            on: { input: _vm.handleSearch },
            model: {
              value: _vm.searchQuery,
              callback: function($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery"
            }
          }),
          _c(
            "div",
            { staticClass: "time-tracking__project__list q-mt-md" },
            [
              _vm.projects.length
                ? [
                    _c(
                      "q-infinite-scroll",
                      {
                        ref: "infiniteScroll",
                        staticStyle: { height: "200px", overflow: "auto" },
                        attrs: { inline: "", handler: _vm.handleLoadMore }
                      },
                      [
                        _c("div", { staticClass: "q-mb-xs" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "time-tracking__project hover-highlight q-py-xs q-px-sm row items-center cursor-pointer",
                              on: {
                                click: function($event) {
                                  _vm.handleSelectProject(null)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "time-tracking__project__color-indicator bg-faded circle"
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "q-subheading text-italic text-faded on-right"
                                },
                                [_vm._v(_vm._s(_vm.$t("without_project")))]
                              )
                            ]
                          )
                        ]),
                        _vm._l(_vm.projects, function(project) {
                          return _c(
                            "div",
                            { key: project.id, staticClass: "q-mb-xs" },
                            [
                              _c("project-indicator", {
                                attrs: {
                                  clickable: "",
                                  project: project,
                                  active: _vm.isActiveProject(project)
                                },
                                on: {
                                  click: function($event) {
                                    _vm.handleSelectProject(project)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "fit row justify-center items-center" },
                      [
                        _c("span", { staticClass: "text-faded" }, [
                          _vm._v(_vm._s(_vm.$t("no_projects_found")))
                        ])
                      ]
                    )
                  ]
            ],
            2
          ),
          _c(
            "div",
            [
              _c("q-btn", {
                attrs: {
                  flat: "",
                  dense: "",
                  "no-caps": "",
                  icon: "add",
                  color: "faded",
                  label: _vm.$tc("project")
                },
                on: { click: _vm.handleAddProject }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("project-modal", {
        ref: "createProjectModal",
        on: { save: _vm.handleSaveProject }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }